import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../MyContext";

const OurBrandsJohnJacobs = (props) => {

    const navigate = useNavigate();

    const { item } = props;

    

    const { imageBaseUrl } = useContext(MyContext);

  const navigateBtn = () => {
    if (
      item.redirectTo != null &&
      item.redirectTo != undefined &&
      item.redirectTo != 0
    ) {
      navigate(`/productsearch?productId=${item.redirectTo}`);
    } else if (
      item.redirectToURL != null &&
      item.redirectToURL != undefined &&
      item.redirectToURL != ""
    ) {
      window.location.href(item.redirectToURL);
    }
  };

  return (
    <div>
      <div onClick={navigateBtn}>
        <div style={{ marginTop: "5px" }}>
          <img
            className="banner-1-style"
            src={
              item.bannerImageId ? `${imageBaseUrl}${item.bannerImageId}` : ""
            }
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default OurBrandsJohnJacobs;